import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { push } from 'connected-react-router';
import queryString from 'query-string';
import axios from 'axios';

import { MainFormControls } from '../jbc-front/components/SearchForm';
import { setOptions } from 'src/reducers/selectOptions';
import AdditionalSearchFields from 'src/components/AdditionalSearchFields';
import * as Urls from 'src/constants/EndpointUrls';
import styles from 'src/components/DetailSearchForm.scss';

const DEFAULT_SEARCH = {
  memo_color_ids: '1_2_3_4_5_6',
  no_memo: '1',
  order: 'asc',
  sort: 'staffCode'
};

const OMIT_FIELDS = ['year_month', 'client_bonus_id', 'payroll_rules_groups', 'page', 'per_page'];

class DetailSearchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpand: false
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const promises = [
      axios.get(Urls.OPTIONS_CLIENT_FLATTEN_GROUPS),
      axios.get(Urls.OPTIONS_CLIENT_POSITIONS),
      axios.get(Urls.OPTIONS_CLIENT_EMPLOYMENT_TYPES, { params: { connected: true } }),
      axios.get(Urls.OPTIONS_CLIENT_OCCUPATIONS),
      axios.get(Urls.OPTIONS_CLIENT_PAYROLL_RULE_GROUPS),
      axios.get(Urls.OPTIONS_OFFICES)
    ];
    Promise.all(promises)
      .then(responses => {
        const [groupsRes, positionsRes, employmentTypesRes, occupationsRes, payrollRuleGroupsRes, officesRes] = responses;
        dispatch(
          setOptions({
            flattenGroups: groupsRes.data.payload.options,
            positions: positionsRes.data.payload.options,
            connectedEmploymentTypes: employmentTypesRes.data.payload.options,
            occupations: occupationsRes.data.payload.options,
            payrollRuleGroups: payrollRuleGroupsRes.data.payload.options,
            offices: officesRes.data.payload.options
          })
        );
      })
      .catch(error => {
        console.log(error);
      });
  }

  render() {
    const {
      menuRender: Menu,
      containsOtherSearch = true,
      containsBonusTarget,
      containAccountTypes,
      containEmployeeEnrollmentStatus,
      formName,
      resetValues,
      resetSearch = '',
      location,
      dispatch
    } = this.props;
    const { isExpand } = this.state;
    const omitedSearch = _.omit(queryString.parse(location.search), OMIT_FIELDS);
    return (
      <div className="u-mb20">
        <div className={styles.mainSearchFields}>
          <Menu />
          <MainFormControls
            isExpand={isExpand}
            hasConditions={
              location.search !== '' &&
              !_.isEqual(omitedSearch, DEFAULT_SEARCH) &&
              location.search !== `?${resetSearch}`
            }
            onToggleClick={() => {
              this.setState({ isExpand: !isExpand });
            }}
            handleClear={() => {
              dispatch(initialize(formName, resetValues));
              dispatch(push({ ...location, search: resetSearch }));
            }}
          />
        </div>
        {isExpand && (
          <AdditionalSearchFields
            {...{ containsOtherSearch, containsBonusTarget, containAccountTypes, containEmployeeEnrollmentStatus }}
          />
        )}
      </div>
    );
  }
}
export default connect(state => ({
  location: state.router.location
}))(DetailSearchForm);
